<template>
  <responsive-modal v-model="visible" title="API do Google Analytics">
    <div class="product-google-analytics-modal">
      <div class="bg-3 rounded-16 p-4 mb-4">
        <div class="d-flex gap-2">
          <i class="ph ph-warning-circle fs-20" />
          <div class="d-flex flex-column">
            <span class="text-dark fs-14">
              Atenção
            </span>
            <span class="text-dark-40 fs-12">
              Certifique-se que você tenha cadastrado o pixel (GA4) de
              rastreamento Google Analytics na {{ $config.get("title") }}
              antes de fazer a configuração da API.
            </span>
          </div>
        </div>
      </div>

      <snow-input
        v-model="form.measurement_id"
        class="mt-3"
        label="ID da Métrica"
        :errors="errors.measurement_id"
      />

      <snow-input
        v-model="form.api_secret"
        class="mt-3"
        label="Chave secreta da API"
        :errors="errors.api_secret"
      />

      <div class="snow-submit-buttons mt-3">
        <snow-button
          text="Salvar"
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
        />
        <snow-button
          text="Cancelar"
          size="lg"
          variant="gray"
          @click="visible = false"
        />
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "api_secret", "measurement_id"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    isValid() {
      return this.form.api_secret && this.form.measurement_id;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form,
        product_id: this.product.id
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(error => {
          this.errors = error.response.data;
          let errorMsg = get(error, "response.data.message");
          this.$message.error(errorMsg ? errorMsg : "Erro ao salvar");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
